import { memo, type ReactNode } from 'react';

export type KeyValueInfoRowProps = {
  label: string;
  value: ReactNode;
  'data-testid'?: string;
};

export const KeyValueInfoRow = memo(({ label, value, 'data-testid': dataTestId }: KeyValueInfoRowProps) => {
  return (
    <div className="flex justify-between" data-testid={dataTestId}>
      <p className="whitespace-nowrap ads:text-metadata text-12 text-gray-9">{label}</p>
      <p className="ml-3 break-words text-right ads:text-secondary text-12 text-gray-11">{value}</p>
    </div>
  );
});

KeyValueInfoRow.displayName = 'KeyValueInfoRow';
